import { Group, Paper, SegmentedControl, Text } from '@mantine/core';
import type { AnySourceConfig, SourceKey } from '../types';

interface Props {
  value: SourceKey;
  sources: Record<SourceKey, AnySourceConfig>;
  onChange: (key: SourceKey) => void;
}

/** Step 1 — pick which dataset (and therefore which API) the page works with. */
export function SourceSelector({ value, sources, onChange }: Props) {
  return (
    <Paper withBorder p="md" radius="md">
      <Group justify="space-between" align="center" wrap="wrap">
        <div>
          <Text fw={600}>1. Data source</Text>
          <Text size="xs" c="dimmed">Switching source loads a different dataset, columns and filters.</Text>
        </div>
        <SegmentedControl
          value={value}
          onChange={(v) => onChange(v as SourceKey)}
          data={(Object.keys(sources) as SourceKey[]).map((k) => ({ value: k, label: sources[k].label }))}
        />
      </Group>
    </Paper>
  );
}